import { UserAggregate } from "@norma-bi/bi-api";

export function mergeUserEmails(user: UserAggregate): string {
  return Array.from(new Set(user.identities.map((i) => i.email)).values()).join(", ");
}
